import { createAgxForm, createFormDefinition } from '@urbanx/agx.forms';
import { isValidEmail } from '@urbanx/agx.ui-components2';
import { z } from 'zod';

const email = z.string().trim().toLowerCase().refine(isValidEmail, 'Enter a valid login email');
const definition = createFormDefinition({
  id: 'support-identity-migration',
  schema: z
    .object({
      sourceEmail: email,
      destinationEmail: email,
      reason: z.string().trim().min(1, 'Enter a reason or ticket reference').max(1000),
      confirmed: z
        .boolean()
        .refine(Boolean, 'Confirm this is the same person receiving a new login'),
    })
    .refine((values) => values.sourceEmail !== values.destinationEmail, {
      path: ['destinationEmail'],
      message: 'Choose a different login email',
    }),
  fieldOrder: ['sourceEmail', 'destinationEmail', 'reason', 'confirmed'],
  resolveFields: () => ({
    sourceEmail: { active: true, visible: true, disabled: false, required: true },
    destinationEmail: { active: true, visible: true, disabled: false, required: true },
    reason: { active: true, visible: true, disabled: false, required: true },
    confirmed: { active: true, visible: true, disabled: false, required: true },
  }),
});
export const IdentityMigrationForm = createAgxForm(definition);
